import { SvuDetail } from '../../svu/components/SvuDetail';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';
import { ManagerMenu } from '../../manager/managermenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';

const ManagerNewSvuPage = () => {
  const { apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.manager ? (
        <AppWrapper
          appType={APP_TYPE.MANAGER}
          menu={<ManagerMenu />}
          resource='R7aUrceniEditoraZps'
          action='create.view'
        >
          <SvuDetail />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default ManagerNewSvuPage;
